import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  addJobsPostingsRoute,
  jobPostingsKey,
  SubmitJobPosting,
} from '@features/jobPostings';
import { errorMessage } from '@features/positions';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';

type UseAddJobPostingProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useAddJobPosting = ({
  setErrorText = () => { },
}: UseAddJobPostingProps) => {
  const client = useQueryClient();

  const { mutate: addJobPosting, isLoading: isAddingJobPosting } = useMutation({
    mutationFn: (variables: SubmitJobPosting) =>
      axiosInstance
        .post(addJobsPostingsRoute, variables, {
          headers: { 'Content-Type': 'multipart/form-data', },
        })
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        setErrorText('');
        client.invalidateQueries([jobPostingsKey]);
        client.invalidateQueries([profileKey]);
      } else if (data.status === 400){
        client.invalidateQueries([profileKey]);
      } else {
        setErrorText(data?.message ?? errorMessage);
      }
    },
    onError: () => setErrorText(errorMessage),
  });

  return { addJobPosting, isAddingJobPosting };
};
